<!-- Header -->
<div class="header">
  <div class="container">
    <div class="header-logo">
      <h3 class="uppercase letter-spacing-1">
        <a routerLink="/">Maximo</a>
      </h3>
    </div>

    <!-- Menu -->
    <div class="header-menu" [ngClass]="{ 'show': isMenuOpen }">
      <ul class="nav">
        <!-- Dropdown Item -->
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(0)">Home</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 0 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/">Creative Agency</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-two">Corporate Agency</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-three">Marketing Agency</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-four">Freelancer</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-five">Designer</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-six">Startup Agency</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 0 }" (click)="toggleDropdown(0)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(1)">Pages</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 1 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/about-us">About Us</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/our-team">Our Team</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/testimonials">Testimonials</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/pricing-table">Pricing Table</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/404-page">404 Error Page</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/coming-soon">Coming Soon</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 1 }" (click)="toggleDropdown(1)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(2)">Services</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 2 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/services">Services</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 2 }" (click)="toggleDropdown(2)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(3)">Portfolio</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 3 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/portfolio-one">Portfolio One</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/portfolio-two">Portfolio Two</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/portfolio-three">Portfolio Three</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 3 }" (click)="toggleDropdown(3)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(4)">Blogs</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 4 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/blog-grid">Blog Grid</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/blog-standard">Blog Standard</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 4 }" (click)="toggleDropdown(4)"></a>
        </li>

        <li class="nav-item" (click)="closeMenu()">
          <a class="nav-link" routerLink="/contact">Contact Us</a>
        </li>
      </ul>
    </div>

    <!-- Social Icons -->
    <div class="header-menu-extra">
      <ul class="list-inline-sm">
        <li><a href="/" class="link-social-facebook"><i class="bi bi-facebook"></i></a></li>
        <li><a href="/" class="link-social-twitter"><i class="bi bi-twitter-x"></i></a></li>
        <li><a href="/" class="link-social-instagram"><i class="bi bi-instagram"></i></a></li>
      </ul>
    </div>

    <!-- Menu Toggle -->
    <button class="header-toggle" [class.toggle-close]="isMenuOpen" (click)="toggleMenu()">
      <span></span>
    </button>
  </div>
</div>
<!-- end Header -->
 
<!-- Hero section -->
<div class="bg-gray border-radius-1 section-sm px-4 px-lg-5 mx-4 mx-lg-5">
    <div class="container">
        <div class="row align-items-center g-4 g-lg-5">
            <div class="col-12 col-lg-7 order-lg-2">
                <img src="assets/images/slides/slide-md-1.png" alt="slide-1">
            </div>
            <div class="col-12 col-lg-5 order-lg-1">
                <h4 class="font-family-philosopher">Turning Ideas Into Visual Magic</h4>
                <h1 class="fw-semi-bold font-family-philosopher">Our creative minds <span class="text-gradient-1">shape your stories</span> into stunning digital experiences, one pixel at a time.</h1>
                <a class="button button-md button-rounded button-gradient-1 mt-3 mt-lg-4" routerLink="/about">More About Us</a>
            </div>
        </div><!-- end row -->
    </div><!-- end container -->
</div>
<!-- end Hero section -->

<!-- Clients section -->
<div class="n-margin-3">
    <div class="container">
        <div class="bg-white border-radius-1 box-shadow p-4 p-lg-5">
            <owl-carousel-o [options]="brandsCarousel" class="owl-btn-center-lr brands-carousel">
                <ng-template carouselSlide *ngFor="let brand of brandStore">
                    <div class="client-box">
                        <a routerLink="/contact"><img src="assets/images/brands/{{brand.img}}" alt="brand-img"></a>
                    </div>
                </ng-template>
            </owl-carousel-o>
        </div><!-- end row -->
    </div><!-- end container -->
</div>
<!-- end Clients section -->

<!-- Services section -->
<div class="section-lg">
    <div class="container text-md-center">
        <div class="row">
            <div class="col-12 text-center">
                <h6 class="d-inline-block bg-gray border-radius px-3 py-2 line-height-140 font-small uppercase letter-spacing-1 mb-3"><span class="text-gradient-1">Services We Offer</span></h6>
                <h2 class="fw-semi-bold mb-0 font-family-philosopher font-italic animate-text">Designs That Speak Louder Than Words.</h2>
            </div>
        </div><!-- end row -->
        <div class="row icon-5xl g-4 mt-4">
            <div *ngFor="let service of services" class="col-12 col-lg-4">
                <div class="border border-radius hover-shadow hover-float p-4 p-lg-5">
                    <i class="bi text-gradient-1" [ngClass]="service.icon"></i>
                    <h4 class="fw-semi-bold mt-2 font-family-philosopher">{{service.title}}</h4>
                    <p>{{service.desc}}</p>
                </div>
            </div>
        </div><!-- end row -->
    </div><!-- end container -->
</div>
<!-- end Services section -->

<!-- Sliding Text -->
<section class="section-sm pt-0">
    <div class="sliding-text pb-3">
        <div class="container-fluid pd-0 overflow-hidden">
            <div class="row">
            <div class="col-12">
                <h2 class="display-1 fw-semi-bold mb-0 opacity-1 text-gradient-1 font-family-philosopher font-italic text-capitalize animate-left">Top Selling HTML Template. Maximo Multipurpose Template.</h2>
            </div>
            </div>
        </div>
    </div>
</section>
<!-- end Sliding Text -->

<!-- Portfolio section -->
<div class="section">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h6 class="d-inline-block bg-gray border-radius px-3 py-2 line-height-140 font-small uppercase letter-spacing-1 mb-3"><span class="text-gradient-1">Our Recent Works</span></h6>
                <h2 class="fw-semi-bold mb-0 font-family-philosopher font-italic animate-text">Future Ready Creative Solutions.</h2>
            </div>
        </div><!-- end row -->
        <!-- Owl Carousel -->
        <div class="mt-4">
            <owl-carousel-o [options]="portfolioCarousel" class="owl-btn-center-lr hero-portfolio-slider">
                <ng-template carouselSlide *ngFor="let portfolio of portfolios">
                    <div class="hero-portfolio-box">
                        <div class="hero-portfolio-img border-radius">
                            <img src="assets/images/portfolio/{{portfolio.img}}" alt="{{portfolio.alt}}">
                        </div>
                        <div class="hero-portfolio-caption border-radius">
                            <h3><a href="#">{{portfolio.title}}</a></h3>
                        </div>
                    </div>
                </ng-template>
            </owl-carousel-o>
        </div>
        <!-- end Owl Carousel -->
    </div><!-- end container -->
</div>
<!-- end Portfolio section -->

<!-- Parallax section -->
<div class="section-2xl bg-image parallax" style="background-image: url('assets/images/backgrounds/video-bg-1.jpg')">
    <div class="bg-dark-03">
        <div class="container text-center">
            <a class="button-circle button-circle-xl button-circle-white-2 button-circle-ripple icon-xl button-hover-shrink lightbox-media-link" (click)="openPopup()">
                <i class="bi bi-play"></i>
            </a>
        </div><!-- end container -->
    </div>
</div>
<!-- end Parallax section -->

<!-- Video Popup -->
<div class="video-popup" *ngIf="isOpen">
    <div class="popup-inner">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/CygqGDPoZWQ?si=0GVlvXAPieQYM4RY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <button (click)="closePopup()" type="button" class="close-btn">
            <i class='bi bi-x'></i>
        </button>
    </div>
</div>

<!-- Team section -->
<div class="section border-top">
    <div class="container">
        <div class="row">
            <div class="col-12 text-center">
                <h6 class="d-inline-block bg-gray border-radius px-3 py-2 line-height-140 font-small uppercase letter-spacing-1 mb-3"><span class="text-gradient-1">Our Team</span></h6>
                <h2 class="fw-semi-bold mb-0 font-family-philosopher font-italic animate-text">Designing Experiences That Inspire.</h2>
            </div>
        </div><!-- end row -->
        <div class="row g-4 gy-5 team-wrapper border-radius mt-4">
            <!-- Team box -->
            <div *ngFor="let member of teams" class="col-12 col-sm-6 col-lg-3 team-box">
            <div class="team-img">
                <img class="img-class" src="assets/images/team/{{member.img}}" alt="{{member.name}}">
                <!-- social links -->
                <div>
                <ul>
                    <li><a href="#"><i class="bi bi-facebook"></i></a></li>
                    <li><a href="#"><i class="bi bi-twitter-x"></i></a></li>
                    <li><a href="#"><i class="bi bi-pinterest"></i></a></li>
                </ul>
                </div>
            </div>
            <h5 class="fw-medium font-family-philosopher m-0">{{member.name}}</h5>
            <p class="text-gradient-1">{{member.designation}}</p>
            </div>
        </div><!-- end row -->
    </div><!-- end container -->
</div>
<!-- end Team section -->

<!-- Facts section -->
<div class="section-lg bg-image parallax" style="background-image: url('assets/images/backgrounds/main-bg-2.jpg')">
    <div class="bg-dark-06">
        <div class="container">
            <div class="row g-4">
                <!-- Counter box -->
                <div *ngFor="let facts of funFactsTwo" class="col-12 col-sm-6 col-md-3">
                    <h1 class="fw-semi-bold"><span class="counter">{{facts.displayedNumber | number:'1.0-0'}}</span>+</h1>
                    <h6 class="font-small fw-normal uppercase mt-2">{{facts.title}}</h6>
                    <p>{{facts.desc}}</p>
                </div>
            </div><!-- end row -->
        </div><!-- end container -->
    </div>
</div>
<!-- end Facts section -->

<!-- Contact section -->
<div class="section">
    <div class="container">
        <div class="row">
            <div class="col-12 text-center">
                <h6 class="d-inline-block bg-gray border-radius px-3 py-2 line-height-140 font-small uppercase letter-spacing-1 mb-3"><span class="text-gradient-1">Get in Touch</span></h6>
                <h2 class="fw-semi-bold mb-0 font-family-philosopher font-italic animate-text">Elevating Brands with Timeless Design.</h2>
            </div>
        </div><!-- end row -->
        <div class="row g-4 mt-4">
            <div class="col-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2 text-center">
                <div class="contact-form text-start">
                    <form (submit)="sendEmail($event)" #contactForm="ngForm">
                        <div class="row gx-3 gy-0">
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <label class="visually-hidden" for="user_name">Name</label>
                                    <input class="border-radius" type="text" minlength="2" maxlength="15" [class.is-invalid]="userName.invalid && userName.touched"
                                        name="user_name" id="name" placeholder="Name *" [(ngModel)]="formData.user_name" #userName="ngModel" required>
                                    <div *ngIf="userName.invalid && userName.touched" class="invalid-feedback mrb-10">
                                        Name is required.
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <input type="email" minlength="2" maxlength="35" [class.is-invalid]="userEmail.invalid && userEmail.touched"
                                        name="user_email" class="md-input border-radius" id="email" placeholder="Email *" [(ngModel)]="formData.user_email"
                                        #userEmail="ngModel" required email>
                                    <div *ngIf="userEmail.invalid && userEmail.touched" class="invalid-feedback mrb-10">
                                        A valid email is required.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="visually-hidden" for="message">Project Details</label>
                            <textarea name="message" [class.is-invalid]="userMessage.invalid && userMessage.touched" class="md-textarea border-radius"
                                id="message" rows="7" placeholder="Project Details" [(ngModel)]="formData.message" #userMessage="ngModel"
                                required></textarea>
                            <div *ngIf="userMessage.invalid && userMessage.touched" class="invalid-feedback mb-10">
                                Project details are required.
                            </div>
                        </div>
                        <button class="button button-lg button-rounded button-font-2 button-gradient-1" type="submit" name="submit" [disabled]="contactForm.invalid" value="Send Message">Send Message</button>
                    </form>
                </div>
            </div>
        </div><!-- end row -->
    </div><!-- end container -->
</div>
<!-- end Contact section -->